<template>
  <div>
    <div class="titlePage">Campos correção cadastral</div>
    <div>Favor defina os campos que poderão ser editados na correção cadastral</div>
    <div v-for="grupo in lstGrupos" :key="grupo.idgrupo">
      <div id="fccGroup" class="groupPage">
        <div class="groupHeader col">
          {{ grupo.dsgrupo }}
        </div>
        <div class="groupBody col" v-for="campos in grupo.lstcampos" :key="campos.idcampo">
          <div class="row">
            <div
              :class="
                !semEdicao.includes(campos.tipovisualizacao['codigounico'])
                  ? 'col-sm-8'
                  : 'col-sm-12'
              "
            >
              {{ campos.nmcampo }}
            </div>
            <div
              class="col-sm-4"
              v-if="!semEdicao.includes(campos.tipovisualizacao['codigounico'])"
            >
              <toggle-button
                @change="editCampo(campos)"
                :disabled="tpPublicacao > 2"
                :sync="true"
                v-model="campos.disponivelcorrecaocadastral"
              />
              Correção Cadastral
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      lstForm: [],
      lstFinalizados: [],

      itemPorPage: '1000',
      lstCampos: [],
      lstGrupos: [],
      semEdicao: ['textoinformativo', 'textoalerta']
    }
  },
  methods: {
    montaForm(lstPaginas) {
      lstPaginas.forEach((element) => {
        element.lstgrupos.forEach((grupo) => {
          this.lstGrupos.push(grupo)
          grupo.lstcampos.forEach((campos) => {
            this.lstCampos.push(campos)
          })
        })
      })
    },
    editCampo: function (item) {
      axios
        .put(
          store.state.baseUrlGestaoForm + 'Campo/AlterarCampo',
          item,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.callToast(this.mensagensUpdate.editado, 'success', 'success', 'top')
        })
        .catch(this.setErrorSystem)
    },
    listarFormulario() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlGestaoForm +
            'Formulario/InserirFormularioInicial/0/' +
            this.controlePage.idpublicacao +
            '/true',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstForm = response.data
          this.montaForm(this.lstForm.lstpaginas)
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    }
  },
  props: {
    controlePage: Object,
    idNotificacao: Number,
    baseUrlPublicacao: String,
    tpPublicacao: Number
  },
  mounted() {
    this.listarFormulario()
  }
}
</script>
